import { render, staticRenderFns } from "./CurrentProductsGrid.vue?vue&type=template&id=72ce576e&scoped=true&"
import script from "./CurrentProductsGrid.vue?vue&type=script&lang=js&"
export * from "./CurrentProductsGrid.vue?vue&type=script&lang=js&"
import style0 from "./CurrentProductsGrid.vue?vue&type=style&index=0&id=72ce576e&scoped=true&lang=css&"
import style1 from "./CurrentProductsGrid.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce576e",
  null
  
)

export default component.exports